import React, {Component} from 'react'
import PropTypes from 'prop-types'
import FilterDateRangeV2 from "../../../shared/FilterDateRangeV2"

class FilterDateCreate extends Component {
    _handleChangeDate = (field, value) => {
        const {onChangeSelect} = this.props

        if (typeof onChangeSelect === 'function') {
            onChangeSelect(field, value)
        }
    }

    render() {
        return (
            <div className="FilterDatePush col-12 col-xl-auto mb-3">
                <label className="font-weight-bold">Ngày tạo</label>
                <FilterDateRangeV2 onDatesChange={this._handleChangeDate} field='created_at'/>
            </div>
        )
    }
}

FilterDateCreate.propTypes = {
    onChangeSelect: PropTypes.func.isRequired
}

export default FilterDateCreate